<div class="utility-panel-container">
  <div class="govuk-grid-row govuk-!-margin-bottom-4 govuk-!-margin-top-0 utility-panel-header">
    {{ heading() }}
  </div>

  <ng-content></ng-content>
</div>
